const fontStyles = {
  NM_500_1rem: {
    fontSize: '1rem',
    fontWeight: '500',
    fontFamily: 'NotoSans-Medium',
  },
  NB_b_1d5rem: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    fontWeight: 'bold',
  },
  NM_500_0d875rem: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: '500',
  },
};

export default fontStyles;
